import React from "react";
import {
  Alert,
  AlertTitle,
  TextField,
  Typography,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import formatValue from "app/utils/formatUtils";

const TestResultItem = ({ test, index, severity }) => (
  <Alert
    severity={severity}
    key={index}
    sx={{ width: "100%", "& .MuiAlert-message": { width: "100%" } }}
  >
    <AlertTitle>
      <Typography variant="h6">Test Case {index + 1}</Typography>
    </AlertTitle>
    <Typography fontWeight="600" sx={{ mb: 2 }}>
      Inputs:
    </Typography>
    {test.problemInputs?.length > 0
      ? test.problemInputs.map((input, inputIndex) => (
          <Div key={inputIndex} display="flex" sx={{ mb: 1 }}>
            <TextField
              key={inputIndex}
              id="outlined-basic"
              label={input.variableName}
              variant="outlined"
              value={formatValue(input.value)}
              disabled
              fullWidth
              sx={{
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#475259",
                  fontSize: "1rem",
                  left: "-2px",
                  top: "-1px",
                },
                "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
                  textFillColor: "#475259",
                },
              }}
            />
          </Div>
        ))
      : null}

    <Typography fontWeight="600" sx={{ mb: 2 }}>
      Expected Output:
    </Typography>
    <Typography variant="body2">
      {test.problemOutputs?.length > 0
        ? test.problemOutputs.map((output, outputIndex) => (
            <Div key={outputIndex} display="flex" sx={{ mb: 1 }}>
              <TextField
                key={outputIndex}
                id="outlined-basic"
                label={output.variableName}
                variant="outlined"
                value={formatValue(output.value)}
                fullWidth
                sx={{
                  "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
                    color: "#475259",
                  },
                  "& .css-i8f0we-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "#475259",
                    fontSize: "1rem",
                    left: "-2px",
                    top: "-1px",
                  },
                }}
              />
            </Div>
          ))
        : null}
    </Typography>

    <Typography fontWeight="600" sx={{ mb: 2 }}>
      Produced Output:
    </Typography>
    <Typography gutterBottom>
      <TextField
        multiline
        id="outlined-basic"
        variant="outlined"
        value={test.executionOutput}
        label="Produced Output"
        fullWidth
        disabled
        sx={{
          "& .MuiInputLabel-root.Mui-disabled": {
            color: "#475259",
          },
          "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
            textFillColor: "#475259",
          },
        }}
      />
    </Typography>
    {test.stdOut && (
      <>
        <Typography fontWeight="600" sx={{ mb: 2 }}>
          Execution logs:
        </Typography>
        <TextField
          multiline
          id="outlined-basic"
          variant="outlined"
          aria-label="Execution logs"
          label="Logs"
          value={test.stdOut}
          disabled
          fullWidth
          sx={{
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#475259",
            },
            "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
              textFillColor: "#475259",
            },
          }}
        />
      </>
    )}
  </Alert>
);

export default TestResultItem;
